import { CanDeactivateFn } from "@angular/router";
import { FlowService } from "../services/beneficiaries-flow.service";
import { inject } from "@angular/core";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { map, take } from "rxjs";
import { StandardConfirmComponent } from "../ui/dialog/standard-confirm/standard-confirm.component";

export const confirmExitGuard: CanDeactivateFn<unknown> = (_cmp, _curr, _currState, next) => {
  const flow = inject(FlowService);
  const dialog = inject(DialogService);

  if (!flow.shouldConfirmExit()) return true;

  const nextUrl = next?.url ?? '';
  const leavingFlow = !nextUrl.startsWith('/beneficiarios/registro');
  if (!leavingFlow) return true;

  const ref: DynamicDialogRef = dialog.open(StandardConfirmComponent, {
    header: 'SALIR',
    closable: false,
    dismissableMask: false,
    width: '30rem',
    data: {
      message: 'Estás por salir. Los datos ingresados se perderán y será necesario comenzar nuevamente.',
      acceptLabel: 'SÍ, SALIR',
      rejectLabel: 'CONTINUAR REGISTRO'
    },
    styleClass: 'bo-dd-confirm'
  });

  return ref.onClose.pipe(
    take(1),
    map((ok: boolean) => {
      if (ok) {
        flow.resetAll();
        return true;
      }
      return false;
    })
  );
};
